import { Menu as MenuIcon } from '@mui/icons-material';
import { Grid, IconButton, Toolbar } from '@mui/material';
import React from 'react';

import { CurrencyExchangeRates } from 'features/currency-exchange';

import { AppBar } from './styles';
import { UserInfo } from './UserInfo';

type Props = {
  onDrawerToggle: () => void;
  onLogout: () => void;
};

export const Navbar: React.FC<Props> = ({ onDrawerToggle, onLogout }) => (
  <AppBar position="sticky" elevation={0}>
    <Toolbar>
      <Grid sx={{ display: { xs: 'block', md: 'none' } }}>
        <IconButton
          color="inherit"
          aria-label="Open drawer"
          onClick={onDrawerToggle}
          size="large"
        >
          <MenuIcon />
        </IconButton>
      </Grid>
      <Grid size="grow" sx={{ overflow: 'auto', mr: 4 }}>
        <CurrencyExchangeRates />
      </Grid>
      <Grid>
        <UserInfo onLogout={onLogout} />
      </Grid>
    </Toolbar>
  </AppBar>
);
